import { toast } from "sonner"
import { Copy } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

type Props = {
  open: boolean
  username: string
  password: string
  onClose: () => void
}

export function VpnPasswordDialog({
  open,
  username,
  password,
  onClose,
}: Props) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(password)
      toast.success("Senha copiada.")
    } catch {
      toast.error("Nao foi possivel copiar a senha automaticamente.")
    }
  }

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Senha do acesso VPN</DialogTitle>
          <DialogDescription>
            Copie a senha de{" "}
            <span className="font-mono font-medium">{username}</span> antes de
            fechar esta tela.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2">
          <Label htmlFor="vpn-generated-password">Senha</Label>
          <Input
            id="vpn-generated-password"
            value={password}
            readOnly
            className="font-mono text-sm"
            onFocus={(e) => e.currentTarget.select()}
          />
        </div>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={handleCopy}>
            <Copy className="size-4" />
            Copiar senha
          </Button>
          <Button type="button" onClick={onClose}>
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
